export default "__VITE_ASSET__1cMcak7U__"